import axios from 'axios';

const baseURL = process.env.REACT_APP_API_HOST;

export const condofy = axios.create({ baseURL });

const condofyProtected = axios.create({
  baseURL
});

condofyProtected.interceptors.request.use(
  async (config) => {
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

export { condofyProtected };
